<template>
  <div class="content">
    <!-- Move to wallet   -->
    <div class="md-layout cards">
      <!-- Wallet Score Card -->
      <div
          class="md-layout-item md-medium-size-33 md-small-size-100 md-size-33"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assessment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Total Events Dispatched</p>
            <h3 class="title">
              {{ webhookHistory.length }}
            </h3>
          </template>
        </stats-card>
      </div>
      <div
          class="md-layout-item md-medium-size-33 md-small-size-100 md-size-33"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assessment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Successful Events</p>
            <h3 class="title">

              {{ successfulEvents.length }}
            </h3>
          </template>
        </stats-card>
      </div>
      <div
          class="md-layout-item md-medium-size-33 md-small-size-100 md-size-33"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assessment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Failed Events</p>
            <h3 class="title">
              {{ failedEvents.length }}
            </h3>
          </template>
        </stats-card>
      </div>
    </div>

    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-content>
            <div>
              <div>
                <md-table table-header-color="green">
                  <md-table-row>
                    <md-table-head>S/N</md-table-head>
                    <md-table-head>Date</md-table-head>
                    <md-table-head>Event Type</md-table-head>
                    <md-table-head>Status</md-table-head>
                    <md-table-head>Webhook Url</md-table-head>
                    <md-table-head>Payload</md-table-head>
                    <md-table-head>Last Response</md-table-head>
                    <md-table-head>Action</md-table-head>
                  </md-table-row>

                  <md-table-row v-if="webhookHistory.length < 1">
                    <md-table-cell colspan="9">
                      <p>No record found.</p>
                    </md-table-cell>
                  </md-table-row>

                  <md-table-row
                      v-for="(history, index) in this.webhookHistory"
                      :key="index"
                  >
                    <md-table-cell md-label="S/N">
                      {{ index + 1 }}
                    </md-table-cell>
                    <md-table-cell md-label="Date">
                      {{ format(history.updated_at, 'DD/MM/YYYY hh:mm a') }}
                    </md-table-cell>
                    <md-table-cell md-label="Event Code">
                      {{ history.event_code }}
                    </md-table-cell>
                    <md-table-cell md-label="Status">
                      {{ history.status }}
                    </md-table-cell>
                    <md-table-cell md-label="Webhook Url">
                      {{ history.url }}
                    </md-table-cell>

                    <md-table-cell md-label="Payload" class="cursor-pointer">
                      <a @click="openJsonData(history.data)">View Payload</a>
                    </md-table-cell>

                    <md-table-cell md-label="Last Response" class="cursor-pointer">
                      <a @click="openJsonData(history.last_response)">View Last Response</a>
                    </md-table-cell>
                    <md-table-cell md-label="Action">
                      <md-button class="md-primary" @click="openConfirmationModal(history)"
                      >Resend Event</md-button
                      >
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <div v-if="webhookHistory.length > 28">
                  <md-button class="md-primary" @click="loadMore()"
                  >Load More</md-button
                  >
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <!-- Modals -->
    <JsonDataModal ref="displayJsonDataModal" :data="jsonData" />
    <Confirmation
      ref="confirmationModal"
      @confirmed="confirmed"
    />
    <md-snackbar
        md-position="center"
        :md-duration="6000"
        :md-active.sync="snackBar.show"
        md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import http from '@/utils/Http.util';
import format from 'date-fns/format';
import JsonDataModal from '@/pages/Settings/Webhook/Modals/JsonDataModal';
import { StatsCard } from '../../../components/index';
import Confirmation from '../../../components/Modals/Confirmation.vue';

export default {
  components: {
    JsonDataModal,
    StatsCard,
    Confirmation,
  },
  mounted() {
    this.webhookHistory = this.$store.state.webhookHistory;
    this.getWebhookHistory();
  },
  computed: {
    successfulEvents() {
      return this.webhookHistory.filter((history) => history.status === 'success');
    },
    failedEvents() {
      return this.webhookHistory.filter((history) => history.status === 'failed');
    },
  },
  data() {
    return {
      webhookHistory: [],
      jsonData: [] || {},
      action: {
        type: '',
        data: [],
      },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },

  methods: {
    format,
    loadMore() {
      this.$store.dispatch('loadMoreWalletLogs');
      this.webhookHistory = this.$store.state.webhookHistory;
    },
    openJsonData(data) {
      this.jsonData = data;
      this.$refs.displayJsonDataModal.open();
    },
    async getWebhookHistory() {
      this.$store.commit('busyStatus', true);

      try {
        this.$store.commit('setWebhookHistory', this.webhookHistory);
        const { data } = await http.authReq('/dashboard/event-notifications');
        this.webhookHistory = data;
        this.$store.commit('setWebhookHistory', this.webhookHistory);
      } catch (error) {
        console.log(error);
      }
      this.$store.commit('busyStatus', false);
    },
    confirmed() {
      switch (this.action.type) {
        case 'resendEvent':
          this.resendEvent(this.action.data);
          break;
        default:
          break;
      }
    },
    async resendEvent(event) {
      this.$store.commit('busyStatus', true);

      try {
        await http.authReq(`/dashboard/event-notifications/${event.id}/dispatch`);

        this.snackBar = {
          show: true,
          message: 'Webhook event fetched dispatched!',
        };

        this.$store.commit('busyStatus', false);
      } catch (error) {
        console.log(error);
      }
    },
    openConfirmationModal(data) {
      this.action = {
        type: 'resendEvent',
        data,
      };
      this.$refs.confirmationModal.open();
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
